export default "__VITE_ASSET__802205b7__"